/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import DealerPageComponents from 'components/Dealer/dealer.components';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const DealerPage = () => {
   return (
      <Fragment>
         <Helmet>
            <title>ดีลเลอร์</title>
         </Helmet>
         <HasAccess
            roles={["Owner"]}
            renderAuthFailed={<ErrorPage404 />}
         >
            <DealerPageComponents />
         </HasAccess>

      </Fragment>
   );
};

export default DealerPage;
